import * as yup from "yup";

// Regex to block emojis
const emojiRegex = /^(?!.*[\p{Emoji}])/u;

const validationSchema = yup.object().shape({
  displayName: yup.string().matches(emojiRegex, "Invalid input"),
  badgeDate: yup.date().nullable().optional(),
  teaching_enjoyment: yup
    .array()
    .of(yup.string().matches(emojiRegex, "Invalid input"))
    .nullable()
    .optional(),
  teaching_style: yup
    .array()
    .of(yup.string().matches(emojiRegex, "Invalid input"))
    .nullable()
    .optional(),
  most_rewarding_aspect: yup
    .array()
    .of(yup.string().matches(emojiRegex, "Invalid input"))
    .nullable()
    .optional(),
  self_description: yup
    .array()
    .of(yup.string().matches(emojiRegex, "Invalid input"))
    .nullable()
    .optional(),
  free_time_activities: yup
    .array()
    .of(yup.string().matches(emojiRegex, "Invalid input"))
    .nullable()
    .optional(),
});

export default validationSchema;
